import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "FormColor" }

import { PropType } from "vue";
import { FormValue } from "@/types";


export default /*#__PURE__*/_defineComponent({
  __name: 'FormColor',
  props: {
    item: {
        type: Object,
        required: true,
    },
    value: {
        type: Object as PropType<FormValue>,
        required: true,
    },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "FormColor__color",
      style: _normalizeStyle({ backgroundColor: __props.value[__props.item.key] })
    }, null, 4),
    _withDirectives(_createElementVNode("input", {
      type: "text",
      placeholder: "Kleur",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((__props.value[__props.item.key]) = $event))
    }, null, 512), [
      [_vModelText, __props.value[__props.item.key]]
    ])
  ]))
}
}

})